import { ProgressBar, Prompt, Typography } from '@capture/capture-components'
import { useSelector } from 'react-redux'
import { _ } from '~/assets/localization/util'
import {
    getFetchRemainingTrashFilesProgress,
    getRestoreAllProgress,
} from '~/state/trash/selectors'

interface RestoreProgressPromptProps {
    isInsideApp?: boolean
}

export const RestoreProgressPrompt = ({
    isInsideApp = false,
}: RestoreProgressPromptProps) => {
    const fetchProgress = useSelector(getFetchRemainingTrashFilesProgress) ?? 0
    const restoreProgress = useSelector(getRestoreAllProgress) ?? 0
    const completePercentage = Math.floor(
        ((fetchProgress + restoreProgress) / 2) * 100,
    )

    return (
        <Prompt.Content
            data-cy="restore_all_progress_prompt"
            title={_('photos_trash__restoring_all')}
            preventCloseOnClickOutside
            hideCloseButton>
            <Typography.Paragraph>
                {isInsideApp
                    ? _('photos_trash__keep_open_app')
                    : _('photos_trash__keep_open')}
            </Typography.Paragraph>
            <ProgressBar value={completePercentage} />
        </Prompt.Content>
    )
}
